<template>
  <div>
    <add-bank-account :is-active.sync="isAdding" :owner="owner" @added="accountAdded" />
    <data-table
      title="Transfer Bank Accounts"
      ref="table"
      :url="url"
      searchable
      :headers="headers"
      :archive="false"
    >
      <template slot="action.icons">
        <v-btn color="primary" @click="isAdding = true">
          Add Bank Account
          <v-icon class="ml-2" color="light-blue lighten-4">
            mdi-account-plus
          </v-icon>
        </v-btn>
      </template>
      <span slot="item.type" slot-scope="{ item }" v-text="getUserType(item)" />

      <template slot="item.status" slot-scope="{ item }">
        <div class="d-flex">
          <div>
            <div v-if="payment.data['bank_account_id'] == item.id">
              <v-btn color="default" disabled>
                Linked bank account
              </v-btn>
            </div>
            <div v-else>
              <v-btn
                v-if="transaction.started_at == null"
                color="success"
                @click="linkToThisTransfer(item)"
              >
                Link to this transfer
              </v-btn>
            </div>
          </div>
          <v-btn color="default" class="ml-2" @click="viewBankDetails(item)">
            view details
          </v-btn>
        </div>
      </template>
    </data-table>
  </div>
</template>

<script>
export default {
  components: { AddBankAccount: require("./addBankAccountForm").default },
  props: {
    transaction: {
      required: false,
    },
    payment: {
      required: true,
    },
    owner: {
      required: true,
    },
  },
  data() {
    return {
      currentFilter: "all",
      isAdding: false,
      showArchived: false,
      accounts: null,

      url: `api/v1/userBankAccounts/all/${this.owner.id}`,
      headers: this.pairTableLabelWithValue({
        Title: "title",
        "Bank Name": "bank_name",
        Country: "country",
        "IBAN CODE": "iban",
        BIC: "bic",
        Status: "status",
      }),
    };
  },

  watch: {
    url() {
      this.$nextTick(() => {
        this.$refs.table.fetchData();
      });
    },
  },
  methods: {
    showDetails({ id }) {
      this.$router.push({ name: "bankaccounts.show", params: { id } });
    },
    updateAccount(account) {
      if (account) {
        this.account = account;
        this.$refs.table.fetchData();

        Notify.success(account.message);
      }
    },
    accountAdded({ message }) {
      this.isAdding = false;
      this.$refs.table.fetchData();
      Notify.success(message);
    },
    linkToThisTransfer(account) {
      const accountId = account.id;
      const paymentId = this.payment.id;
      Notify.confirm(`Please Confirm to Link this bank account`).then(() => {
        this.$http
          .post(`/api/v1/payments/transferbankaccount/${paymentId}/${accountId}`)
          .then((result) => {
            Notify.success(result.message);
            window.location.reload();
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error) => {
            Notify.error(error.message);
          });
      });
    },
    viewBankDetails({ id }) {
      this.$router.push({ name: "bankaccounts.show", params: { id } });
    },
  },
};
</script>
